export const EMPTY_INPUT_MESSAGE =
    "Geben Sie eine Nachricht ein, um fortzufahren";
export const LONG_INPUT_MESSAGE = "Bitte formulieren Sie Ihre Eingabe kürzer";
export const INPUT_MAX_LENGTH = 150;

export const INPUT_PLACEHOLDER = "Tippen Sie Ihre Frage ein";

// Welcome screen
export const DISCLAIMER =
    '<p>Bitte beachten Sie die <a target="_blank" href="https://www.arbeitsagentur.de/datenschutz">Datenschutz Hinweise</a> und den <a target="_blank" href="https://www.arbeitsagentur.de/rechtliche-hinweise">Haftungsausschluss</a>.</p>'
export const DISCLAIMER_UA =
    '<p>Зверніть увагу на <a target="_blank" href="https://www.arbeitsagentur.de/datenschutz">інформацію про захист даних</a> і <a target="_blank" href="https://www.arbeitsagentur.de/rechtliche-hinweise">застереження</a>.</p>'
export const WELCOME_TEXT_INTRO =
    "<p>Hallo!<br>Ich bin der Chatbot der Bundesagentur für Arbeit. Ich bin ein KI-gestütztes, automatisiertes System – also kein Mensch.</p>"; // *KI gestützte*
export const DZT_WELCOME_TEXT_INTRO =
    "<p>Hallo!<br>Ich bin der Chatbot der Bundesagentur für Arbeit. Ich bin ein KI-gestütztes, automatisiertes System – also kein Mensch. Ich beantworte Fragen zu vielen Themen und stelle Informationen zur Verfügung.</p>";
export const FORM_WELCOME_TEXT_INTRO =
    "Hallo!<br><br>Ich bin der Chatbot der Bundesagentur für Arbeit. Ich bin ein KI-gestütztes, automatisiertes System – also kein Mensch.";

export const FLOATING_BUTTON_LABEL = "Digitalen Assistenten öffnen";

// ARIA labels:
export const BOT_IS_LOADING = "Chatbot lädt, bitte warten Sie";
export const BOT_HAS_TIMEOUT = "Leider ist ein Fehler aufgetreten, daher steht der <br> Chatbot derzeit nicht vollständig zur Verfügung. <br> Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.";

export const BOT_ALERT = "Digitalen Assistenten Popup";
export const ALERT_YES_BTN = "Ja und Digitalen Assistenten öffnen";
export const ALERT_NO_BTN = "Nein und Popup schließen";

export const BOT_AVATAR = "Chatbot Avatar";
export const LS_BOT_TOGGLE_BUTTON = "Leichte Sprache Chatbot öffnen";

// Stamp text
export const USER_CHANGES_THEME =
    "Ich möchte gerne eine Frage zu einem anderen Thema stellen";
export const FORM_THEME_STAMP = "Abbrechen und zurück zum Hauptmenü";
export const START_THEME_STAMP_PART_1 = "Themenbereich";

// Feedback
export const FEEDBACK_GIVEN_STAMP = "Feedback erhalten";
export const FEEDBACK_WITHDRAWN_STAMP = "Feedback gelöscht";
export const POSITIVE_FEEDBACK_PAYLOAD = "/feedback_positive";
export const NEGATIVE_FEEDBACK_PAYLOAD = "/feedback_negative";

// ERROR
export const TECHNICAL_ERROR =
    "Entschuldigung, ich scheine mein Wissen gerade nicht abrufen zu können.<br/> Bitte laden Sie die Seite neu oder versuchen es zu einem späteren Zeitpunkt noch einmal.";
export const MAIL_TECHNICAL_ERROR =
    "Aus technischen Gründen können wir Ihre Anfrage derzeit nicht bearbeiten.<br/> Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.";
